import type { PetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

type VideoFirstExperiment = PetitionDetailsPageUserData['experiments']['videoFirstPetitionPage'];

type Result = Readonly<{
	experiment: VideoFirstExperiment;
	hasVideoFirstSource: boolean;
	videoFirstSourceUrl: string | undefined;
}>;

export function useVideoFirstExperiment(): Result {
	const {
		data: { videoFirstHero },
	} = usePetitionDetailsPageData();
	const {
		data: {
			ownPetition,
			experiments: { videoFirstPetitionPage: experiment },
		},
	} = usePetitionDetailsPageUserData();

	const hasVideoFirstSource = videoFirstHero.enabled;
	// The FCM-gated source remains the kill switch, but starters bypass their GrowthBook assignment.
	const showVideoFirstHero = ownPetition || experiment.variation === 'video_first';
	const videoFirstSourceUrl = videoFirstHero.enabled && showVideoFirstHero ? videoFirstHero.sourceUrl : undefined;

	return { experiment, hasVideoFirstSource, videoFirstSourceUrl };
}
